import styled from '@emotion/styled'
import { Button, TextStylePreset, Typography } from '@vivaldis/antd-ui'
import { Edit } from '@vivaldis/icons'
import { useTranslation } from 'react-i18next'
import { ContactRequiredInformation } from './components/ContactRequiredInformation'
import { AdditionalInformation } from './components/AdditionalInformation'
import { EmployeeProfileQuery_employee } from '../../typings/EmployeeProfileQuery'
import { Information } from '../../../Information'

interface Props {
  employee: EmployeeProfileQuery_employee
}

export const GeneralInformation = ({ employee }: Props) => {
  const [t] = useTranslation('web_ui')

  return (
    <>
      <Base>
        <Typography.Paragraph
          preset={TextStylePreset.Semibold16}
          marginBottom={0}
        >
          {t('employee_profile.general_information_header')}
        </Typography.Paragraph>
        <Button
          to={`/employee/${employee.id}/edit-employee-general-information`}
          openInSideSheet
          type="default"
          shape="round"
          icon={<Edit />}
        >
          {t('employee_profile.edit_general_information_button')}
        </Button>
      </Base>
      <Information>
        <ContactRequiredInformation employee={employee} />
        <AdditionalInformation employee={employee} />
      </Information>
    </>
  )
}

const Base = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin-bottom: 16px;
`
